export default __webpack_public_path__ + "static/media/icon-people-first.d7caeec6.svg";